export default __webpack_public_path__ + "static/media/Apparels_2.dcfd4650.webp";